export default __webpack_public_path__ + "static/media/Ring of the Vampire Squid.2a60514d.jpg";